import { tv } from '~/utils/tv'

export const SwitchThumbVariants = tv({
  base: `
    flex w-extrasmall h-extrasmall bg-[white] rounded-pill data-[state=checked]:translate-x-[16px] transition-transform
  `,
  variants: {},
})
